// Firebase configuration for LinkedIn Local Cameroon 2026
// ===========================================================
// TODO: Replace the placeholder values below with your actual Firebase config.
// 1. Go to https://console.firebase.google.com
// 2. Create a new project (or use an existing one)
// 3. Go to Project Settings > General > Your apps > Web app
// 4. Copy the firebaseConfig object and paste the values below
// 5. Enable Firestore Database in the Firebase console
// ===========================================================

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDK5RV3ZQJ2dd3_HhZQs83VlktVbRsd4Dg",
  authDomain: "v-labs-b023b.firebaseapp.com",
  projectId: "v-labs-b023b",
  storageBucket: "v-labs-b023b.appspot.com",
  messagingSenderId: "275150662573",
  appId: "1:275150662573:web:7f46451208165e1a810f24"
};

// Initialize Firebase
let app;
let db;

try {
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);
} catch (error) {
  console.warn('Firebase not configured yet. Running in offline mode.', error.message);
  db = null;
}

export { db };
export default app;
